import { useNavigate } from "@tanstack/react-router";

import { useDownloadExcelFileReport, useDownloadOfferForTypicalMarkups } from "../../../entity/reporting";
import { AccessDenied } from "../../components/access-denied";
import { useUserRolesGGE } from "../../hooks";

export const ReportsPage = () => {
  const navigate = useNavigate();
  const roles = useUserRolesGGE();
  const { mutate: getOfferForTypicalMarkups } = useDownloadOfferForTypicalMarkups();
  const { mutate: getFileExport } = useDownloadExcelFileReport();

  const items = [
    {
      title: "Статистика по использованию ПО",
      onClick: () => navigate({ to: "/reports/statistics-usage-software" }),
    },
    { title: "Предложения по типовым замечаниям", onClick: () => getOfferForTypicalMarkups() },
    { title: "Файловый отчёт", onClick: () => getFileExport() },
  ];

  if (roles.МОДЕРИРОВАНИЕ || roles.ПРОСМОТР || roles.НЕТ) {
    return <AccessDenied />;
  }

  return (
    <main className="relative flex h-full flex-col">
      <header className="flex flex-col gap-6 px-8 pb-6 pt-8">
        <h1 className="heading-h4">Отчёты</h1>
        <div className="flex flex-col gap-4 rounded-xl bg-white px-6 py-8">
          {items.map((item) => (
            <div key={item.title} onClick={item.onClick} className="text-system-info-50 hover:bg-neutrals-99 cursor-pointer px-3 py-2">
              {item.title}
            </div>
          ))}
        </div>
      </header>
    </main>
  );
};
